import { HTTPStatusCode } from "@libs/api/types";
import { CreateNpsSurveyType } from "@/domain/npsSurveys";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const NpsSurveysApi = {
  createNpsSurvey: async (body: CreateNpsSurveyType) => {
    const res = await tsRestClient().npsSurveys.createNpsSurvey({ body });

    if (res.status === HTTPStatusCode.CREATED) {
      return res.body;
    }

    sendSentryError({
      message: "Unexpected response in NpsSurveysApi.createNpsSurvey",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
